import { getPropClassesFromInstance } from 'lib/getPropClasses';
import cx from 'classnames';
import pickGlobalElementProps from 'utils/pickInputElementProps';
import * as React from 'react';

import './styles/Badge.scss';

/**
 * ## Displays a numeric value within a colored container.
 * ### Typically placed in proximity of an icon or line of text in order to indicate new activity on a particular object, like a class or person.
 *
 * ```example
 * <div>
 *   <Badge count={5} />
 *   <Badge
 *     color="lava"
 *     count={0}
 *     shape="square"
 *   />
 *   <Badge
 *     color="brand"
 *     count={1}
 *     size="large"
 *   />
 * </div>
 * ```
 *
 *
 * # TODO
 * * Consider removing options given limted usage, clean up and clarify remaining props
 */

type BadgeColor = 'lava' | 'brand' | 'koala' | 'violet' | 'white';
type BadgeShape = 'circle' | 'square';
type BadgeSize = 'large' | 'medium';

type Props = {
  color: BadgeColor;
  count: number;
  shape: BadgeShape;
  size: BadgeSize;
  className?: string;
};

type DefaultProps = {
  color: BadgeColor;
  shape: BadgeShape;
  size: BadgeSize;
};

class Badge extends React.Component<Props> {
  static propClasses = {
    color: {
      lava: 'Badge--lava',
      brand: 'Badge--brand',
      koala: 'Badge--koala',
      violet: 'Badge--violet',
      white: 'Badge--white',
    },
    shape: {
      circle: 'Badge--circle',
      square: 'Badge--square',
    },
    size: {
      medium: 'Badge--medium',
      xsmall: 'Badge--xsmall',
    },
  };

  static defaultProps: DefaultProps = {
    color: 'violet',
    shape: 'circle',
    size: 'large',
  };

  render() {
    const { className, count, ...others } = this.props;
    const divProps = pickGlobalElementProps(others);

    return (
      <div {...divProps} className={cx('Badge', getPropClassesFromInstance(this), className)}>
        {count}
      </div>
    );
  }
}

export default Badge;
